import { useEffect, useState } from "react";
import { Accessibility } from "lucide-react";
import { useLocale } from "@/contexts/LocaleContext";

const STORAGE_KEY = "immozwerg-high-contrast";

/** Bedienhilfe im gemeinsamen Footer: erreichbar, ohne Seiteninhalte zu überlagern. */
export default function AccessibilityControls() {
  const [highContrast, setHighContrast] = useState(false);
  const { t } = useLocale();

  useEffect(() => {
    setHighContrast(localStorage.getItem(STORAGE_KEY) === "true");
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("high-contrast", highContrast);
    localStorage.setItem(STORAGE_KEY, String(highContrast));
  }, [highContrast]);

  return (
    <section className="immozwerg-accessibility-controls" aria-labelledby="accessibility-controls-heading">
      <div className="immozwerg-accessibility-footer-copy">
        <h2 id="accessibility-controls-heading" className="immozwerg-accessibility-footer-title">Bedienhilfen</h2>
        <p className="immozwerg-accessibility-footer-description">Darstellung anpassen</p>
      </div>
      <div className="immozwerg-accessibility-actions flex flex-wrap items-center gap-2">
        <button
        type="button"
        onClick={() => setHighContrast(value => !value)}
        aria-pressed={highContrast}
        aria-label={highContrast ? t("highContrastOff") : t("highContrastOn")}
        className="immozwerg-contrast-toggle min-h-11 rounded-full px-4 py-2.5 text-sm font-bold shadow-lg transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-2"
      >
        <Accessibility size={18} aria-hidden="true" />
        <span>{highContrast ? t("standardView") : t("highContrast")}</span>
        </button>
      </div>
      <div className="immozwerg-accessibility-help">
        <p><strong>Kontrast:</strong> erhöht die Lesbarkeit von Texten und Bedienelementen.</p>
      </div>
    </section>
  );
}
